/*
 * @Author: yangxu
 * @Description:
 * @Date: 2023-07-18 16:24:04
 * @LastEditTime: 2025-03-12 14:08:52
 * @FilePath: /js_zuhe-2023_src/src/utils/Util.js
 */

// 检查当前页面是否在测试环境中
const _isTest = window.location.host.match("test");

// 从 URL 中获取指定参数的值
export const getUrlParam = function (string) {
  // 构造一个含有目标参数的正则表达式对象
  const reg = new RegExp(`(^|&)${string}=([^&]*)(&|$)`);
  // 匹配目标参数
  const r = window.location.search.substr(1).match(reg);
  // 返回参数值
  if (r != null) {
    return decodeURIComponent(r[2]); // 解码并返回参数值
  } else {
    return null; // 如果没有匹配到参数，返回 null
  }
};

// 获取用户代理字符串并转换为小写
const ua = navigator.userAgent.toLowerCase();

// 检查是否在华信应用中
export const isHxApp = ua && ua.indexOf("hxappid") > -1;

// 检查是否在微信中
export const isWx = ua && ua.match(/MicroMessenger/i);

// 获取指定长度的整数字符串
const getIntStrAtLength = function (value, length) {
  let str = value.toString(); // 将值转换为字符串
  if (length > 1) {
    if (str.length > length) {
      str = str.substr(-length); // 如果字符串长度大于指定长度，截取最后 length 位
    } else {
      while (str.length < length) {
        str = `0${str}`; // 如果字符串长度小于指定长度，在前面补 0
      }
    }
  }
  return str; // 返回处理后的字符串
};

// 格式化日期
export const format = function (date, formatStr) {
  return formatStr.replace(/([YMWDhms])\1*/g, function (...args) {
    const matchStr = args[0]; // 匹配到的格式字符串
    let replaceStr;
    switch (matchStr.charAt(0)) {
      case "Y":
        replaceStr = getIntStrAtLength(date.getFullYear(), matchStr.length); // 年份
        break;
      case "M":
        replaceStr = getIntStrAtLength(date.getMonth() + 1, matchStr.length); // 月份
        break;
      case "W":
        replaceStr = getIntStrAtLength(this.weeks(date), matchStr.length); // 周数
        break;
      case "D":
        replaceStr = getIntStrAtLength(date.getDate(), matchStr.length); // 日期
        break;
      case "h":
        replaceStr = getIntStrAtLength(date.getHours(), matchStr.length); // 小时
        break;
      case "m":
        replaceStr = getIntStrAtLength(date.getMinutes(), matchStr.length); // 分钟
        break;
      case "s":
        replaceStr = getIntStrAtLength(date.getSeconds(), matchStr.length); // 秒
        break;
      default:
        replaceStr = ""; // 默认为空字符串
        break;
    }

    return replaceStr; // 返回替换后的字符串
  });
};

// 解析 JSONP 字符串
export const parseJSONP = (jsonpString) => {
  try {
    const start = jsonpString.indexOf("('") + 2; // 找到 JSONP 字符串的起始位置
    const end = jsonpString.lastIndexOf("')"); // 找到 JSONP 字符串的结束位置
    if (start === 0 || end === -1) {
      throw new Error("无效的JSONP格式"); // 如果起始或结束位置无效，抛出错误
    }
    const jsonStr = jsonpString.slice(start, end); // 截取 JSON 字符串
    return JSON.parse(jsonStr); // 解析并返回 JSON 对象
  } catch (error) {
    console.error("解析JSONP失败:", error); // 打印错误信息
    throw error; // 抛出错误
  }
};

// 将数字转换为两位小数的字符串
export const toDecimal = (x) => {
  let f = parseFloat(x); // 将输入转换为浮点数
  if (isNaN(f)) {
    return ""; // 如果不是数字，返回空字符串
  }
  f = Math.round(x * 100) / 100; // 四舍五入到两位小数
  let s = f.toString(); // 将浮点数转换为字符串
  let rs = s.indexOf("."); // 找到小数点位置
  if (rs < 0) {
    rs = s.length; // 如果没有小数点，设置小数点位置为字符串末尾
    s += "."; // 添加小数点
  }
  while (s.length <= rs + 2) {
    s += "0"; // 补充小数点后两位
  }
  return s; // 返回处理后的字符串
};

/**
 * @description: 格式化时间
 * @param {*} business_time
 * @return {*}
 */
export const formatBusinessTime = (business_time) => {
  let a = business_time.split("");
  a.splice(2, 0, ":");
  a.splice(5, 0, ":");
  return a.join("");
};
